import { useQuery } from '@tanstack/react-query';
import { getServices } from '@infrastructure/services';
import { useSession } from '../providers/SessionProvider';

/**
 * The name of the session's own sub area.
 *
 * The sidebar identifies a person by where they sit — «Marco Rivas / Desarrollo
 * iOS» — rather than by their role, which the top bar already states. Like the
 * area name this is editable, so it is resolved rather than carried in a claim.
 *
 * Someone with no sub area (an area administrator, a superuser) gets the
 * fallback; the caller decides what that should read as.
 */
export const useSubAreaName = (fallback = ''): string => {
  const session = useSession();

  const subAreas = useQuery({
    queryKey: ['organization', 'subAreas', session.areaId],
    staleTime: 5 * 60 * 1000,
    enabled: session.subAreaId !== null,
    queryFn: async () => {
      const result = await getServices().organization.listSubAreas(session.areaId);
      return result.ok ? result.value : [];
    },
  });

  if (session.subAreaId === null) return fallback;
  return (subAreas.data ?? []).find((sub) => sub.id === session.subAreaId)?.name ?? fallback;
};
